export const THREE_SECTION_SLIDER_BLOCK_IMAGE_SIZES = {
  SMALL: 80,
  MEDIUM: 130,
};
